// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal--442b1"};